import Navigation from "../../components/navigation/Navigation";
import React from "react";
import {useDefaultLayoutStyles} from "./DefaultLayoutStyles";

const DefaultLayout = ({children}) => {
    const classes = useDefaultLayoutStyles()

    return (
        <Navigation>
            <main className={classes.main}>
                {children}
            </main>
        </Navigation>
    )
}

export default DefaultLayout;
